import * as React from 'react';

function Sad(props) {
	return (
		<svg
			width="60"
			height="60"
			viewBox="0 0 60 60"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z"
				fill="#689CFA"
			/>
			<path
				opacity="0.5"
				d="M36.4286 55.5707C19.8601 55.5707 6.42875 42.1393 6.42875 25.5709C6.42875 16.7189 10.2633 8.76372 16.3612 3.27246C6.64894 8.23837 0 18.3425 0 29.9996C0 46.5681 13.4314 59.9994 29.9998 59.9994C37.7165 59.9994 44.7517 57.085 50.0672 52.2982C45.9753 54.3903 41.34 55.5707 36.4286 55.5707Z"
				fill="#1F4B99"
			/>
			<path
				d="M43.6481 49.6629H29.0798C28.4056 49.6629 27.8594 49.1167 27.8594 48.4426C27.8594 47.7684 28.4057 47.2222 29.0798 47.2222H43.6481C44.3223 47.2222 44.8685 47.7684 44.8685 48.4426C44.8685 49.1167 44.3223 49.6629 43.6481 49.6629Z"
				fill="#1F4B99"
			/>
			<path
				d="M25.7411 37.1036C22.7731 37.1036 20.0916 36.3441 18.5682 35.0722C18.0507 34.6403 17.9815 33.8706 18.4136 33.3533C18.8454 32.836 19.615 32.7666 20.1325 33.1987C21.1979 34.0881 23.3993 34.6629 25.7412 34.6629C28.027 34.6629 30.2587 34.0772 31.4268 33.1713C31.9592 32.7581 32.7257 32.855 33.1391 33.3875C33.5523 33.9199 33.4554 34.6865 32.9229 35.0997C31.3052 36.3544 28.6205 37.1036 25.7411 37.1036Z"
				fill="#1F4B99"
			/>
			<path
				d="M46.911 37.1036C43.943 37.1036 41.2615 36.3441 39.7381 35.0722C39.2206 34.6404 39.1515 33.8707 39.5835 33.3533C40.0156 32.8359 40.7851 32.7667 41.3024 33.1987C42.3678 34.0882 44.5693 34.663 46.9111 34.663C49.197 34.663 51.4287 34.0773 52.5968 33.1713C53.1291 32.7581 53.8958 32.855 54.309 33.3875C54.7222 33.9199 54.6253 34.6865 54.0928 35.0997C52.475 36.3545 49.7903 37.1036 46.911 37.1036Z"
				fill="#1F4B99"
			/>
			<path
				d="M19.9616 30.8582C19.5081 30.8582 19.086 30.8073 18.7098 30.7032C18.0602 30.5236 17.6793 29.8511 17.8589 29.2015C18.0387 28.5519 18.7116 28.1708 19.3607 28.3506C19.9615 28.5171 21.1944 28.4002 22.5951 27.7647C23.9662 27.1432 24.897 26.2635 25.2112 25.6677C25.5256 25.0713 26.2637 24.8428 26.8599 25.1573C27.4562 25.4717 27.6846 26.21 27.3703 26.806C26.7308 28.0187 25.3225 29.208 23.6032 29.9877C22.3465 30.5577 21.0619 30.8582 19.9616 30.8582Z"
				fill="#1F4B99"
			/>
			<path
				d="M52.3769 30.8591C51.2763 30.8591 49.9921 30.5585 48.7351 29.9885C47.0158 29.2091 45.6077 28.0197 44.9683 26.8071C44.6538 26.2111 44.8824 25.4728 45.4787 25.1584C46.0749 24.8435 46.8131 25.0726 47.1274 25.6688C47.4418 26.2645 48.3724 27.144 49.7432 27.7656C51.1441 28.401 52.3775 28.5178 52.9777 28.3515C53.6281 28.1724 54.2997 28.5526 54.4795 29.2023C54.6591 29.8519 54.2784 30.5243 53.6287 30.7041C53.2525 30.8082 52.8303 30.8591 52.3769 30.8591Z"
				fill="#1F4B99"
			/>
		</svg>
	);
}

export default Sad;
